// hooks/scraperHooks.js
const RAW_API = (process.env.REACT_APP_ADMIN_API || "").trim();
const API = RAW_API.replace(/\/$/, "");
const TOKEN = (process.env.REACT_APP_ADMIN_TOKEN || "").trim();
const authHeader = TOKEN ? { "x-admin-token": TOKEN } : {};
const base = API || ""; // 

function apiBase() {
  // If API env is empty, we’ll use relative URLs (requires a dev/prod proxy/rewrite)
  return API || "";
}

function jsonOrThrow(res) {
  const ct = (res.headers.get("content-type") || "").toLowerCase();
  if (!ct.includes("application/json")) {
    return res.text().then(t => {
      const snippet = t.slice(0, 200).replace(/\n/g, " ");
      throw new Error(`Expected JSON, got ${ct || "unknown"} from ${res.url}. Snippet: ${snippet}`);
    });
  }
  return res.json();
}

export async function fetchJSON(url, opts = {}) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 15000);
  try {
    const res = await fetch(url, { signal: controller.signal, ...opts });
    if (!res.ok) {
      const body = await res.text();
      throw new Error(`${res.status} ${res.statusText} @ ${url} :: ${body.slice(0, 200)}`);
    }
    return jsonOrThrow(res);
  } finally {
    clearTimeout(timer);
  }
}

export async function listVenues(limit = 1000, fast = true) {
  const url = `${base}/api/admin/venues?limit=${limit}&fast=${fast ? 1 : 0}`;
  const res = await fetch(url, { headers: { ...authHeader } });
  if (!res.ok) throw new Error(`GET ${url} -> ${res.status}`);
  return res.json();
}

export async function runScraper(slug) {
  if (!slug) throw new Error("Missing slug");
  const url = `${apiBase()}/api/admin/run-scraper`;
  return fetchJSON(url, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader },
    body: JSON.stringify({ venueSlug: slug }),
  });
}
